import type { FaireProductEntity } from "../../entity_types/product";

export const p_sgxnvybduz: FaireProductEntity = {
  token: "p_sgxnvybduz",
  type: "product",
  name: "EUPHORIA",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/c37204644a7e3dc06d2267b966cb78b8859eaf41b7336a630d340df5d4d55a6a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd87a3e8fd2ad13003dcc3efa97706bbb77c5d3db4b85d80a22280012e81fa4b.jpeg"
  ],
  priceDollars: 18,
  description: "The euphoric scent of spring time in the Silver Lake neighborhood of Los Angeles. Blooming bougainvillea cascades along fences while the gorgeous bouquet of night blooming jasmine and osmanthus fill the air. Balanced with exotic white musk and soft undertones of vanilla, this is a floral for both floral lovers and non-floral lovers alike.\n\nstar jasmine, lily, osmanthus, white musk, greens\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n7 ounces (198g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:04.685Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
